<template>
  <div>
    <tuoyuIndex v-if="$route.params.plat_type == 'tuoyu'"></tuoyuIndex>
    <yingyouIndex v-else-if="$route.params.plat_type == 'yingyou'"></yingyouIndex>
    <jiazhang06Index v-else-if="$route.params.plat_type == 'jiazhang06'"></jiazhang06Index>
    <jiazhang03Index v-else-if="$route.params.plat_type == 'jiazhang03'"></jiazhang03Index>
    <div class="index is-search" :style="{ paddingTop: $store.state.headerHeight + 'px' }" v-loading="pageLoading"
      v-else>
      <SubHeader :showUser="true" :showNav="false"></SubHeader>
      <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white" v-if="swiperData.length">
        <van-swipe-item v-for="item in swiperData" :key="item.id">
          <img :src="item.cover" @click="goDetail(item.url)" />
        </van-swipe-item>
      </van-swipe>
      <div class="menu" v-if="plat != 120">
        <div class="item" v-for="(item, index) of indexData" :key="index" @click="goProductList(index)">
          <img :src="require('../assets/icon/' + (index + 1) + '.png')" class="icon" alt="" />
          <p class="name">{{ item.category_name }}</p>
        </div>
        <div class="line"></div>
      </div>

      <div class="index-vip" style="display:none" v-if="plat != 120 && !vipInfo.is_buy" @click="toVIP">
        <!-- 不是会员1 -->
        <div class="btn">
          开通会员
        </div>
      </div>
      <div class="index-vip2" style="display:none" v-else-if="plat != 120" @click="toVIP">
        <!-- 是会员 -->
        <div class="content">
          <b>尊敬的会员用户</b>
          您的会员有效期到{{ vipInfo.end_time }}
        </div>

        <div class="btn">
          立即续费
        </div>
      </div>

      <div class="part-title">
        <div class="part-title_text">{{ $store.state.plat_id == '107' || $store.state.plat_id == '121' ? 'VIP课程' :
          '基础课程' }}</div>
      </div>
      <van-tabs color="#A40001" :ellipsis="false" v-if="!pageLoading && menuData.length" title-active-color="#333"
        v-model="active" class="tab index-tab">

        <van-tab title-class="tab-class" v-for="(item, index) of menuData" :title="item.category_name" :key="index">
          <div class="tab-warp" v-loading="listLoading">
            <div scroll-y="true" class="tab-list" v-if="item.goods.length">
              <van-list v-model="item.loading" :finished="true" finished-text="">
                <PriceCard v-for="(card, index) of item.goods" :key="index" :cardData="card"
                  @click.native="goDetail(card.id)"></PriceCard>
              </van-list>
            </div>
            <van-empty class="tab-list" style="margin: 0 auto" v-if="!item.goods.length" description="暂无数据" />
          </div>
        </van-tab>
      </van-tabs>
      <div class="quality" v-if="demonstrate.length">
        <div class="part-title part-title2" v-if="!pageLoading">
          <div class="part-title_text">示范课</div>
          <div class="part-title_more" @click="goList('demonstrate')">查看更多></div>
        </div>
        <van-tabs color="#A40001" :ellipsis="false" v-if="!pageLoading" title-active-color="#333" v-model="active2"
          class="tab index-tab">

          <van-tab title-class="tab-class" v-for="(item, index) of demonstrate" :title="item.category_name"
            :key="index">
            <div class="tab-warp" v-loading="listLoading">
              <div scroll-y="true" class="tab-list" v-if="item.goods.length">
                <van-list v-model="item.loading" :finished="true" finished-text="">
                  <PriceCard v-for="(card, index) of item.goods" :key="index" :cardData="card"
                    @click.native="goDetail(card.id)"></PriceCard>
                </van-list>
              </div>
              <van-empty class="tab-list" style="margin: 0 auto" v-if="!item.goods.length" description="暂无数据" />
            </div>
          </van-tab>
        </van-tabs>
        <!-- <div class="quality-list">
      <PriceCard v-for="(item, index) of qualityData" :key="index" :cardData="item" @click.native="goDetail(item.id)"></PriceCard>
    </div>
    <div class="line"></div> -->
      </div>
      <div class="live" style="padding-bottom:20px"
        v-if="(plat == 118 || plat == 119 || plat == 120) && liveData.length">
        <div class="part-title" v-if="!pageLoading">
          <div class="part-title_text">直播专栏</div>
          <div class="part-title_more" @click="goList('live')">查看更多></div>
        </div>
        <van-tabs color="#A40001" :ellipsis="false" v-if="liveData.length > 1" title-active-color="#333"
          v-model="active3" class="tab index-tab">

          <van-tab title-class="tab-class" v-for="(item, index) of liveData" :title="item.category_name" :key="index">
            <div class="tab-warp" v-loading="listLoading">
              <div class="hot-list tab-list">
                <LiveCard v-for="(item, index) of item.data" :key="index" :cardData="item"
                  @click.native="goLiveDetail(item)"></LiveCard>
              </div>
              <van-empty class="tab-list" style="margin: 0 auto" v-if="!item.data.length" description="暂无数据" />
            </div>
          </van-tab>
        </van-tabs>

        <div class="hot-list" v-else-if="liveData[0].data.length">
          <LiveCard v-for="(item, index) of liveData[0].data" :key="index" :cardData="item"
            @click.native="goLiveDetail(item)"></LiveCard>
        </div>
        <van-empty v-else class="tab-list" style="margin: 0 auto" description="暂无数据" />
      </div>


      <!-- <SubFooter :active="0"></SubFooter> -->
    </div>
  </div>

</template>

<script>
import PriceCard from "@/components/PriceCard";
import VideoCard from "@/components/VideoCard";
import TopCard from "@/components/TopCard";
import SubHeader from "@/components/SubHeader";
import SubFooter from "@/components/SubFooter";
import LiveCard from "@/components/LiveCard";
import tuoyuIndex from './Index2.vue'
import yingyouIndex from './IndexYingyou.vue'
import jiazhang06Index from './IndexJiazhang06.vue'
import jiazhang03Index from './IndexJiazhang03.vue'
import { resolve } from "path";
import { Toast } from "vant";

// import Vue from 'vue'
// import VConsole from 'vconsole';
// Vue.prototype.Vconsole = new VConsole()

export default {
  components: {
    PriceCard,
    VideoCard,
    TopCard,
    SubHeader,
    SubFooter,
    LiveCard,
    tuoyuIndex,
    yingyouIndex,
    jiazhang06Index,
    jiazhang03Index
  },
  computed: {
    titleName() {
      return this.$store.state.plat.name;
    },
    plat() {
      return this.$store.state.plat_id;
    },
    indexTab() {
      return this.$store.state.indexTab;
    },
    indexData() {
      console.log("this.$store.state.plat", this.$store.state.plat);
      if (
        this.$store.state.plat_id == "119" ||
        this.$store.state.plat_id == "118"
      ) {
        return this.$store.state.plat.indexData;
      } else {
        let arr = this.menuData.map((e) => {
          return e;
        });
        arr.push({
          category_id: 0,
          category_name: "全部分类",
        });
        return arr;
      }
    },
  },
  data() {
    return {
      tabActive: "index",
      active: 0,
      active2: 0,
      active3: 0,
      pageLoading: true,
      listLoading: false,
      swiperData: [],
      menuData: [],
      hotData: [],
      qualityData: [],
      topData: [],
      limit: 10,
      current: 0,
      liveData: [],
      certData: [],
      demonstrate: [],
      vipInfo: {}
    };
  },

  async mounted() {
    window.localStorage.setItem('isH5', window.location.search.indexOf('isH5') > -1 ? 1 : 0);
    // 衡水项目新增需求
    sessionStorage.setItem('isHengShui', window.location.hash.indexOf('isHengShui') > -1 ? 1 : 0)
    console.log(window.location.href)
    if (this.$route.query.phone || this.$route.query.mobile) {
      this.autoLogin()
    }
  },
  methods: {
    will() {
      this.$toast('敬请期待');
    },
    change(event) {
      this.current = event.detail.current;
    },
    async autoLogin() {
      await this.$request.mobileLogin({
        mobile: this.$route.query.phone ? this.$route.query.phone : this.$route.query.mobile
      })
      this.pageLoading = false;
      if (!this.$route.query.from && !this.$until.isWeiXin()) {
        console.log('跳转了q多')
        this.$router.replace('/'+this.$route.params.plat_type+'/index')
        // window.location.replace(window.location.href.split('?')[0])
      }
      console.log('发票非常棒')
    },
    async init() {
      let res = await this.$api({
        // url: "/api/users/university/index",
        url: `/api/platform/pc/index?plat_id=${this.plat}&terminal=1`,
      });
      this.pageLoading = false;
      if (res.code == 0) {
        let {
          category,
          content_knowledge,
          like,
          choice_course,
          top_list,
          banner,
          live_stream,
          certificate,
          p_vip,
          vip_end_days,
          plat_vip,
          demonstrate
        } = res.data;
        this.demonstrate = demonstrate
        this.menuData = category;
        this.hotData = content_knowledge;
        this.qualityData = choice_course;
        this.topData = top_list;
        this.swiperData = banner;
        this.liveData = live_stream;
        this.certData = certificate;
        this.vipInfo = plat_vip;
        this.pageLoading = false;
        this.$store.commit('SET_VIP', plat_vip)
      } else {
        this.$toast(res.msg);
      }
    },
    jumpUser() { },
    async getUser() {
      let res = await this.$api({
        url: "/api/auth/me",
      });
      if (res.code == 0) {
        this.$store.commit("setUser", res.data);
      }
    },

    goDetail(id) {
      if (!id) return
      let url = `./detail?id=${id}`

      this.$router.push(url);
    },
    goLiveDetail(item) {
      let {
        name,
        video_url,
        host,
        img_url,
        category_name,
        video_id,
        ccid,
        cover,
        id
      } = item;
      let videoId = video_id;
      let type = 'aliyun'
      if (ccid) {
        id = ccid;
        type = 'cc';
      }
      if (video_url) {
        this.$router.push(`./LiveDetail?id=${id}&name=${name}&url=${video_url}&host=${host}&cover=${img_url}&category_name=${category_name}`);
      } else if (videoId) {
        this.$router.push(`./LiveDetail?id=${id}&name=${name}&videoId=${videoId}&type=${type}&cover=${cover}`);

      } else {
        this.$toast('没有视频')
      }

    },
    goList(type) {
      this.$router.push(`./${type}`);
    },
    goProductList(index) {
      if (this.plat == 118 || this.plat == 119) {
        this.will();
      } else {
        this.$router.push(`./lesson?index=${index}`);
      }
    },
    toVIP() {
      if (!localStorage.getItem('token')) {
        this.$dialog.confirm({
          title: '提示',
          message: '请登录后查看',
          confirmButtonText: '立即登录',
        })
          .then(() => {
            // on confirm
            this.$router.push('./login/phone')
          })
          .catch(() => {
            // on cancel
          });
      } else {
        this.$router.push({
          path: './vip/detailVIP',
          query: {
            id: this.vipInfo.goods_id
          }
        })
      }
    }
  },
};
</script>

<style lang="scss">
.part-title_text {
  font-weight: bold;
}

.my-swipe {
  width: 690px;
  margin: 10px auto 0;

  img {
    width: 100%;
    border-radius: 10px;
  }
}

.index-vip {
  width: 690px;
  height: 172px;
  margin: 23px auto 18px;
  display: block;
  background: url('https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/gaoyanyuan/vip.png') no-repeat;
  background-size: 100%;
  position: relative;
}

.index-vip2 {
  width: 690px;
  height: 172px;
  margin: 23px auto 18px;
  display: block;
  background: url('https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/isVipBg.png') no-repeat;
  background-size: 100%;
  position: relative;
}

.index-vip2 .content {
  position: absolute;
  left: 30px;
  top: 40px;
  color: #6a4a2c;
  font-size: 24px;
}

.index-vip2 .content b {
  display: block;
  font-weight: bold;
  font-size: 34px;
  margin-bottom: 15px;
}

.index-vip .btn,
.index-vip2 .btn {
  position: absolute;
  bottom: 37px;
  right: 37px;
  width: 155px;
  height: 56px;
  background: #6a4a2c;
  border-radius: 28px;
  text-align: center;
  line-height: 56px;
  color: #fff;
  font-size: 26px;
}

.index {
  min-height: 100vh;
  overflow: hidden;
}

.is-search {
  padding-top: 100px;
  box-sizing: border-box;
}

.tab {
  // padding-top: 35px;
}

.tab-class {
  color: #333;
  font-size: 30px;
}

.tab-warp {
  // height: calc(100vh - 88px - 96px);
  padding-bottom: 10px;
}

.tab-list {
  // height: calc(100vh - 88px - 96px);
  padding: 30px 0 0;
  box-sizing: border-box;
  overflow: hidden;
}

.swiper-wrap {
  width: 690px;
  height: 270px;
  margin: 11px auto 0;
  overflow: hidden;
  background: #fff;
  position: relative;
}

.swiper {
  height: 100%;
  width: 100%;
}

.swiper-item {
  display: block;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  text-align: center;
  border-radius: 12px;
}

.page {
  position: absolute;
  right: 19px;
  bottom: 14px;
  color: #fff;
  font-size: 24px;
  letter-spacing: 2px;
  height: 40px;
  line-height: 40px;
  padding: 0 18px;
  border-radius: 20px;
  background: rgba(0, 0, 0, 0.2);
}

.menu {
  width: 100vw;
  display: flex;
  align-items: center;
  padding: 0 5px;
  flex-wrap: wrap;

  .item {
    flex: 0 1 148px;
    width: 148px;
    text-align: center;
    margin-top: 40px;
  }

  .icon {
    width: 78px;
    height: 78px;
    display: inline-block;
    margin-bottom: 10px;
  }

  .name {
    font-size: 24px;
    color: #333333;
    line-height: 33px;
  }

  .line {
    width: 690px;
    height: 2px;
    background: #eee;
    margin: 34px auto 10px;
  }
}

.hot {
  width: 100vw;

  .hot-list {
    width: 100%;
    padding: 0 30px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-bottom: 30px;
  }
}

.quality {
  width: 100vw;

  .quality-list {
    width: 100%;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }
}

.top {
  width: 100vw;

  .top-list {
    width: 100%;
    padding: 0 30px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-top: 10px;
    overflow: auto;
  }

  .list-wrap {
    white-space: nowrap;
    // width: 100%;
  }
}
</style>
